import React from "react";
import { useTranslation } from "react-i18next";

import { CustomSelect } from '../../components/Shared/CustomSelect';

const languagesOptions = [
    { value: 'hy', label: 'Armenian' },
    { value: 'en', label: 'English' },
    { value: 'ru', label: 'Russian' },
];

export const LanguageSelect = ({ formik }) => {
    const { t } = useTranslation();


    const defaultLanguage = languagesOptions.find((option) => option.value === formik.values.language) || null;

    const handleChange = (option) => {
        formik.setFieldValue("language", option.value);
        if(!formik.values[option.value]) {
            formik.setFieldValue(option.value, { title: "", description: "" });
        }
    };

    return (
        <CustomSelect
            options={languagesOptions}
            name="language"
            value={defaultLanguage}
            onChange={handleChange}
            placeholder={t("Select Language")}
        />
    );
};
